import {getDateUtilDefaultInstance} from '/util/date.util';

export const maximumBBB = '+12%';
export const lowerIntermediateBBB = '+8%';
export const higherIntermediateBBB = '+10%';
export const minimumBBB = '+6%';

export const maximumFQV = 10000;
export const lowerIntermediateFQV = 3600;
export const higherIntermediateFQV = 6000;
export const minimumFQV = 1200;

// @ts-expect-error TS(7030): Not all code paths return a value.
export const getBusinessBuilderBonusValue = ({fqv}: any) => {
  if (fqv >= 1200 && fqv <= 3599.99) {
    return 6;
  } else if (fqv >= 3600 && fqv <= 5999.99) {
    return 8;
  } else if (fqv >= 6000 && fqv <= 9999.99) {
    return 10;
  } else if (fqv >= 10000) {
    return 12;
  }
};

export const isTextBold = (bonusValue: any, fqv: any) => {
  if (bonusValue.includes(getBusinessBuilderBonusValue({fqv})?.toString())) {
    return true;
  }
  return false;
};

export function getCurrentMonthName(date: any) {
  const dateUtil = getDateUtilDefaultInstance();
  const formattedMonth = dateUtil
    .formatDate(new Date(date), 'MMMM')
    ?.toLocaleString('default', {month: 'long'});
  return formattedMonth;
}

export function getFormattedMonthName(month: any) {
  return month?.charAt(0).toUpperCase() + month?.slice(1).substring(0, 2);
}
